// Resolve legend values against current data items: recalculation replaces them,
// while the cursor can still refer to a previous item at the same timestamp.
export function configureIndicatorLiveValues(indicator) {
  if (indicator.constructor?.className === 'VolumeProfile') return { dispose() {} };
  const series = indicator.series;
  if (!series?.events) return { dispose() {} };
  let pending, disposed = false;
  const original = series.updateLegendValue;
  const resolve = requested => {
    const hovered = indicator.get('stockSeries')?.get('tooltipDataItem')
      || requested || series.get('tooltipDataItem');
    const time = hovered?.get('valueX') ?? Infinity;
    const items = series.dataItems || [];
    for (let i = items.length - 1; i >= 0; i--) {
      const point = items[i];
      if (point.get('valueX') <= time && Number.isFinite(point.get('valueY'))) return point;
    }
  };
  // Axis/cursor processing may clear the legend AFTER datavalidated. Apply the
  // same resolution to those calls instead of racing them with one frame callback.
  const update = function (point) { return original.call(this, resolve(point)); };
  series.updateLegendValue = update;
  const refresh = () => {
    pending = undefined;
    if (disposed || indicator.isDisposed?.() || series.isDisposed?.()) return;
    series.updateLegendValue();
  };
  const schedule = () => {
    if (!disposed && !pending) pending = series.root.events.once('frameended', refresh);
  };
  const listener = series.events.on('datavalidated', schedule);
  schedule();
  return { dispose() {
    disposed = true; listener.dispose(); pending?.dispose();
    if (series.updateLegendValue === update) series.updateLegendValue = original;
  } };
}
